import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import HotelCard from "@/components/HotelCard";
import SEO from "@/components/SEO";

export default function DestinationDetail() {
  const { key } = useParams();
  const [destination, setDestination] = useState(null);
  const [hotels, setHotels] = useState([]);

  useEffect(() => {
    api.get("/destinations").then(({ data }) => {
      setDestination(data.find((d) => d.key === key));
    });
    api.get("/hotels", { params: { destination: key, limit: 30 } }).then(({ data }) => setHotels(data));
  }, [key]);

  if (!destination) return <div className="container-x py-28 text-center text-charcoal/60">Loading…</div>;

  return (
    <div>
      <SEO
        title={`Where to stay in ${destination.name}`}
        description={destination.blurb}
        image={destination.image}
      />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={destination.image} alt={destination.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/40 via-charcoal/10 to-sand" />
        </div>
        <div className="relative container-x pt-24 pb-32 md:pt-32 md:pb-44 max-w-3xl">
          <div className="overline text-sand/80">{destination.state} · USA</div>
          <h1 className="mt-4 font-serif text-6xl md:text-7xl leading-[0.95] tracking-tight text-sand">{destination.name}</h1>
          <p className="mt-6 text-sand/90 text-lg max-w-xl">{destination.blurb}</p>
          <Link to="/operators" className="btn-primary mt-8" data-testid="dest-cta-compare">Compare operators</Link>
        </div>
      </section>

      <section className="container-x py-16">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="overline text-terracotta">What to book in {destination.name}</div>
            <h2 className="mt-2 font-serif text-4xl md:text-5xl">{hotels.length} curated properties — ranked</h2>
          </div>
        </div>
        <div className="space-y-4 md:space-y-5">
          {hotels.map((h, i) => <HotelCard key={h.id} hotel={h} variant="list" rank={i + 1} />)}
        </div>
      </section>
    </div>
  );
}
